module.exports = __webpack_public_path__ + "static/media/login-bg.1c79217d.png";